import { Helmet } from "react-helmet";
import { Outlet } from "react-router-dom";
import { SortOrder } from "@covertree/agent-portal-graphql";
import { TableView } from "@covertree/ui/table/TableView";
import { LoadingOverlay } from "@covertree/ui";

import { useGetRenewals } from "./useGetRenewals";
import formatPageTitle from "@utils/formatPageTitle";

export default function Renewals() {
  const {
    loading,
    isAnyActionLoading,
    error,
    renewals,
    columns,
    filters,
    sortBy,
    order,
    totalCount,
    rowsPerPage,
    currentPage,
    handleChangePage,
    handleFilterChange,
    handleSortChange,
    handleRowsPerPageChange,
  } = useGetRenewals();

  return (
    <>
      <Helmet>
        <title>{formatPageTitle("Renewals")}</title>
      </Helmet>
      <TableView
        header="Renewals"
        loading={loading}
        error={error}
        tabs={filters}
        totalCount={totalCount}
        page={currentPage}
        rows={renewals}
        rowsPerPage={rowsPerPage}
        sortBy={sortBy}
        sortOrder={order === SortOrder.Ascending ? "asc" : "desc"}
        columns={columns}
        onTabChange={handleFilterChange}
        onPageChange={handleChangePage}
        onSortChange={handleSortChange}
        onRowsPerPageChange={handleRowsPerPageChange}
      />
      {isAnyActionLoading && <LoadingOverlay />}
      <Outlet />
    </>
  );
}
